import React from "react";
import { useSelector } from "react-redux";
import { selectPaperworkMetadata } from "store/PaperWork/selectors";
import { Text, Wrapper, State, CreatorData } from "./styled";
import get from "lodash/get";
import { PAPERWORK_STATE, PAPERWORK_STATE_NAME } from "store/PaperWork/constants";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const Header = () => {
  const paperworkProgress = useSelector(selectPaperworkMetadata);
  const id = get(paperworkProgress, "id", "");
  const state = get(paperworkProgress, "state", "");
  const finishDate = get(paperworkProgress, "finishDate", "-");
  const finishAuthor = get(paperworkProgress, "finishAuthor.name", "-");
  const stateName = get(PAPERWORK_STATE_NAME, state, "-");
  const isFinished = state === PAPERWORK_STATE.APPROVED || state === PAPERWORK_STATE.REJECTED;
  const { pathname } = useLocation();
  const currentSection = pathname.split("/")[1];
  const hidden = currentSection === "tramites";

  if (hidden) return null;
  return (
    <Wrapper>
      <Text>{`Trámite #${id}. Estado:`}</Text>
      <State state={state}>{stateName} </State>
      {isFinished && <CreatorData>{`el ${finishDate} por ${finishAuthor}`}</CreatorData>}
    </Wrapper>
  );
};

export default Header;
